import { IFullAnalysisFileRecord } from "./FullAnalysisTypes";
import { IAnalysisFolder } from "./IAnalysisFolder";

export type IPlanarFolder = Omit<IAnalysisFolder, 'folderItems'> & {parent: string, folderItems: Array<string> | null, avatarUrl?: string}

export const iterateFolderChildren = (folder: IAnalysisFolder, onIterate: (folder: IAnalysisFolder, parent:IAnalysisFolder | null)=>void, parent: IAnalysisFolder | null = null)=>{
    onIterate(folder, parent);
    if (folder.folderItems){
        folder.folderItems.forEach(it=>{
            iterateFolderChildren(it, onIterate, folder);
        });
    }
}

export const FSPlanarize = (folder: IAnalysisFolder)=>{
    const planarized: IPlanarFolder[] = [];
    iterateFolderChildren(folder, (child, parent)=>{
        planarized.push({
            ...child,
            folderItems: child.folderItems?.map(it=> it.id) || null,
            parent: parent?.id || null,
        })
    });
    return planarized;
}

export const FSResolve = (planarized: Array<IPlanarFolder>) => {
    const folderMap: Record<IPlanarFolder['id'], IPlanarFolder> = {};
    planarized.forEach(it=>{
        if (folderMap[it.id]){
            throw new Error('Folder id is dublicated '+ it.id + it.name);
        }
        folderMap[it.id] = it;
    });

    const rootPlanar = planarized.find(it=>it.parent == null);

    const transform = (folder: IPlanarFolder)=>{
        const resolved: IAnalysisFolder = {
            ...folder,
            folderItems: folder.folderItems?.map(it=> transform(folderMap[it])) || null
        };
        return resolved;
    }

    const resolved = rootPlanar ? transform(rootPlanar) : null;
    return resolved;
}

export const makeAnalysisForClient = (clientId: string, planarized: Array<IPlanarFolder>) => {
    const files = planarized.filter(item=>{
        return item.type == 'file' && (item.name.endsWith('.analysis') || item.mimeType=='text/analysis') && item.fileData;
    });

    const result: IFullAnalysisFileRecord[] =[];
    files.forEach(file=>{
        file.fileData.forEach(record=>{
            if (record.relatedClientId == clientId){
                result.push(record);
            }
        })
    });
    return result;
}